/* eslint-disable */
import store from './store/index'
import axios from 'axios'
(function ($) {
    'use strict';

    // Plugin default options
    var defaultOptions = {
    };

    // If the plugin is a button
    function buildButtonDef (trumbowyg) {
        return {
            fn: function () {
                var input = document.createElement('input');
                input.type = 'file';
                input.multiple = true
                input.accept = "image/*"

                const url = trumbowyg.o.plugins.multiupload.apiUrl
                const authToken = store.getters.getAuthToken
                const config = {headers: {Authorization: `Bearer ${authToken}`}}

                input.onchange = e => {
                    for (const file of e.target.files) {
                        var form = new FormData();
                        form.append('file', file);

                        axios.post(url, form, config)
                            .then((response) => {
                                const url = response.data.data
                                trumbowyg.execCmd('insertImage', process.env.VUE_APP_API_URL + url, false, true);
                            })

                    }
                }

                input.click();
            },
            ico: 'insertImage'
        }
    }

    $.extend(true, $.trumbowyg, {
        // Add some translations
        langs: {
            en: {
                myplugin: 'My plugin'
            }
        },
        // Register plugin in Trumbowyg
        plugins: {
            myplugin: {
                // Code called by Trumbowyg core to register the plugin
                init: function (trumbowyg) {
                    // Fill current Trumbowyg instance with the plugin default options
                    trumbowyg.o.plugins.myplugin = $.extend(true, {},
                        defaultOptions,
                        trumbowyg.o.plugins.myplugin || {}
                    );

                    // If the plugin is a button
                    trumbowyg.addBtnDef('multiupload', buildButtonDef(trumbowyg));
                },
                // Return a list of button names which are active on current element
                tagHandler: function (element, trumbowyg) {
                    return [];
                },
                destroy: function (trumbowyg) {
                }
            }
        }
    })
})(jQuery);
